import { useParams } from "react-router-dom";
import PerformanceEvaluationResultsState from "../context/PerformanceEvaluationResultsContext/PerformanceEvaluationResultsState"
import PerformanceEvaluationResults from "../components/PerformanceEvaluationResults/PerformanceEvaluationResults"
import Header from "../components/Header/Header";


const PerformanceEvaluationResultsScreen = () => {
  const { typeUser,idEvalPerformance,userId} = useParams<{ typeUser: string; idEvalPerformance: string ,userId:string}>();
  return (    
    <PerformanceEvaluationResultsState>
          { typeUser === 'leader' || typeUser === 'collaborator' ?            
            <div className="scrolledQual">
            <Header fromLink />
            <div style={{
              backgroundColor: "#F5F6F9",
              minHeight: "calc(100vh - 74px)",
              padding: '10px 50px 0px 50px'
            }}>               
              <div>        
              <PerformanceEvaluationResults
                idPerformanceEval={idEvalPerformance}
                idUser={userId}
                typeUser={typeUser}
              />                
              </div>
            </div>
          </div>:
           <PerformanceEvaluationResults/>
          }
    </PerformanceEvaluationResultsState>
  )
}

export default PerformanceEvaluationResultsScreen
